const expand = {
  dynamicEntity: { select: 'id,displayName' },
};

const itemSelect =
  'id,order,required,displayText,internalName,type,dynamicEntityId,dynamicEntityFieldId,groupingType,dynamicTableFieldOrderDirection,isAllowMultipleChoicesEnabled,choices,isAutoSelectItemEnabled,isAllowInsertOptionManuallyEnabled,created,updated,creator,modifier';

export default {
  paged: {
    select: 'id,order,required,displayText,internalName,type,dynamicEntityId,dynamicEntityFieldId',
    searchSelect: ['displayText', 'internalName'],
    orderBy: 'order asc',
  },
  item: {
    select: itemSelect,
    expand,
  },
  itemDetail: {
    select: itemSelect,
    expand,
  },
};
